import { render } from "./EntranceExitPreviewCreate.vue?vue&type=template&id=2d540a32"
import script from "./EntranceExitPreviewCreate.vue?vue&type=script&lang=js"
export * from "./EntranceExitPreviewCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__